import { Component } from 'preact';
import StorageContext from './store/storage_context';
import queryString from 'query-string';
import CreateReview  from './containers/create_review';

import {
    TG_WIDGET_ACCESS_TOKEN,
    TG_WIDGET_JWT,
    TG_WIDGET_MEMBER_ID,
    TG_WIDGET_THEME,
    TG_WIDGET_MEMBER_DATA,
    TG_WIDGET_BRANDING,
    TG_WIDGET_HEADER_FOOTER,
    TG_WIDGET_WEBSITE_USER_ID,
    TG_WIDGET_DOMAIN_OWNER_ID,
    TG_WIDGET_X_THEME
} from './config/keys';

import './app.scss';
import { IQueryParams } from './interfaces/query_params';
import { authenticateAccessToken } from './utils/authenticate';
import { getAllBranding }  from './api/branding';

interface IAppProps {
    Widget: any;
    memberID: string;
    accessToken?: string;
    branding?: string;
    headerFooter?: string;
    websiteUserID?: string;
    domainOwnerID?: string;
}

interface IAppState {
    loaded: boolean;
    queryParams: IQueryParams;
    memberError: boolean;
}

class App extends Component<IAppProps, IAppState> {

    constructor(props: IAppProps) {
        super(props);

        this.state = {
            loaded: false,
            memberError: false,
            queryParams: null
        };
    }

    async componentDidMount () {
        const {
            accessToken,
            memberID,
            headerFooter,
            websiteUserID,
            domainOwnerID,
            branding
        } = this.props;

        localStorage.clear();

        this.setXTheme(branding);

        if (accessToken) {
            this.setAccessToken(accessToken);
        }

        if (memberID) {
            this.setMemberID(memberID);
        }

        if (headerFooter) {
            this.setHeaderFooter(headerFooter);
        }

        if (websiteUserID) {
            this.setWebsiteUserID(websiteUserID);
        }

        if (domainOwnerID) {
            this.setDomainOwnerID(domainOwnerID);
        }

        let memberError = false;

        try {
            const jwt = await authenticateAccessToken(branding);
            if (!jwt) {
                throw new Error('JWT Is null ');
            }
        } catch(err) {
            console.error(`authenticate access toke failed: ${err.message}`);
            memberError = true;
        }

        const { themeData, brandingData } = getAllBranding(branding);
        localStorage.setItem(TG_WIDGET_BRANDING, JSON.stringify(brandingData));
        localStorage.setItem(TG_WIDGET_THEME, JSON.stringify(themeData));

        const queryParams: IQueryParams = this.loadQueryParams();

        this.setState({
            loaded: true,
            queryParams,
            memberError
        });

        console.log(`componentDidMount: accessToken ${accessToken} memberID ${memberID}`);
    }

    setXTheme = (theme: string) => localStorage.setItem(TG_WIDGET_X_THEME, theme);

    setMemberID(memberID: string) {
        localStorage.setItem(TG_WIDGET_MEMBER_ID, memberID);
    }

    setHeaderFooter(headerFooter: string) {
        localStorage.setItem(TG_WIDGET_HEADER_FOOTER, headerFooter);
    }

    setWebsiteUserID(websiteUserID: string) {
        localStorage.setItem(TG_WIDGET_WEBSITE_USER_ID, websiteUserID);
    }

    setDomainOwnerID(domainOwnerID: string) {
        localStorage.setItem(TG_WIDGET_DOMAIN_OWNER_ID, domainOwnerID);
    }

    setAccessToken(accessToken: string) {
        localStorage.setItem(TG_WIDGET_ACCESS_TOKEN, accessToken);
    }

    setJWT(jwt: string) {
        localStorage.setItem(TG_WIDGET_JWT, jwt);
    }

    loadQueryParams = (): IQueryParams => {
        
        const params: IQueryParams = {
            inviteToken: null,
            overallRatingValue: null,
            firstName: null,
            lastName:null,
            emailAddress: null,
            rs: null,
            cid: null,
            ct: null
        };

        if (window.location.search) {
            const queryParams: any = queryString.parse(window.location.search);
        
            if (queryParams.inviteToken) {
                params.inviteToken = queryParams.inviteToken;
            }

            if (queryParams.overallRatingValue) {

                const rating = parseInt(queryParams.overallRatingValue, 10);
                if (!isNaN(rating)) {
                    params.overallRatingValue = rating;
                }
            }

            if (queryParams.firstName) {
                params.firstName = queryParams.firstName;
            }

            if (queryParams.lastName) {
                params.lastName = queryParams.lastName;
            }

            if (queryParams.emailAddress) {
                params.emailAddress = decodeURIComponent(queryParams.emailAddress);
            }

            if (queryParams.rs) {
                params.rs = queryParams.rs;
            }

            if (queryParams.CID) {
                params.cid = queryParams.CID;
            }

            if (queryParams.CT) {
                params.ct = queryParams.CT;
            }
        }

        return params;
    };

    render() {

        const { loaded, memberError, queryParams } = this.state;

        if (!loaded) {
            return <div />;
        }

        if (memberError) {
            const branding = localStorage.getItem(TG_WIDGET_BRANDING) ? JSON.parse(localStorage.getItem(TG_WIDGET_BRANDING)) : {};
            const logo: any = branding ? branding.Logo : '';
            const siteName: any = branding ? branding.SiteName : '';

            return (
                <div className="kt-portlet create-review-success">
                    <div className="kt-portlet__body px-0">
                        <img src={logo} className={`logo-${siteName}`} alt={siteName} />
                        <h1 className="mt-4">
                            <h1>Sorry we could not find this Community</h1>
                        </h1>
                    </div>
                </div>
            );
        }

        const { Widget } = this.props;
        const jwt = localStorage.getItem(TG_WIDGET_JWT); 
        const accessToken = localStorage.getItem(TG_WIDGET_ACCESS_TOKEN); 
        const memberID = localStorage.getItem(TG_WIDGET_MEMBER_ID);
        const theme = JSON.parse(localStorage.getItem(TG_WIDGET_THEME));
        const memberData = JSON.parse(localStorage.getItem(TG_WIDGET_MEMBER_DATA));
        const branding = JSON.parse(localStorage.getItem(TG_WIDGET_BRANDING));
        const headerFooter = JSON.parse(localStorage.getItem(TG_WIDGET_HEADER_FOOTER));
        const websiteUserID = JSON.parse(localStorage.getItem(TG_WIDGET_WEBSITE_USER_ID));
        const domainOwnerID = JSON.parse(localStorage.getItem(TG_WIDGET_DOMAIN_OWNER_ID));
        const xTheme = localStorage.getItem(TG_WIDGET_X_THEME);

        const storageData: any = {
            auth: { accessToken, jwt, memberID, websiteUserID },
            branding,
            headerFooter,
            memberData,
            theme,
            queryParams,
            domainOwnerID,
            memberID,
            xTheme
        };

        if (Widget) {
            return (
                <div className="tg-widget">
                    <StorageContext.Provider value={storageData}>
                        <Widget />
                    </StorageContext.Provider>
                </div>
            );
        }

        return (
            <div className="tg-widget">
                 <StorageContext.Provider value={storageData}>
                    <CreateReview />
                </StorageContext.Provider>
            </div>
        );
    }
}

export default App;
